/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkOffIcon20Solid = forwardRef('AttachLinkOffIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2.796 1.204a1.125 1.125 0 0 0-1.591 1.592l16 16a1.125 1.125 0 0 0 1.59-1.591l-1.93-1.932A6 6 0 0 0 14 4h-1.751a1 1 0 1 0 0 2H14a4 4 0 0 1 1.355 7.764L12.591 11H14a1 1 0 1 0 0-2h-3.409l-3-3h.159a1 1 0 1 0 0-2H6c-.133 0-.265.004-.396.013L2.796 1.205Z" }),
        React.createElement("path", { d: "M1.697 5.818A6 6 0 0 0 6 16h1.75a1 1 0 1 0 0-2H6a4 4 0 0 1-2.888-6.767L1.697 5.818Z" })));
});
